<template>
  <div class="field-input" :class="{ 'has-error': $validator.errors.has(name, validateScope) }">
    <el-input :type="type"
              v-model="internalValue"
              :disabled="disabled === true"
              :readonly="readonly === true"
              :placeholder="placeholder"
              :name="name"
              v-validate="internalValidate"
              :data-vv-as="validateLabel"></el-input>
    <input type="hidden" :ref="name + 'TargetValidateValue'" :value="targetValue"/>
    <span class="error-message"><strong>{{$validator.errors.first(name, validateScope)}}</strong></span>
  </div>
</template>

<script lang="js">
import FormatUtil from '../../../utils/format'

export default {
  name: 'FieldInputTargetCmp',
  components: {},
  props: {
    value: null,
    name: '',
    placeholder: null,
    validate: null,
    validateLabel: '',
    validateScope: null,
    disabled: Boolean,
    readonly: Boolean,
    type: {type: String, default: 'text'},
    targetValidateMethod: null,
    targetValue: null
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data () {
    return {
      internalValue: FormatUtil.num2FracStr(this.value),
      internalValidate: Object.assign({}, this.validate)
    }
  },
  created () {
    const orgParams = this.internalValidate[this.targetValidateMethod]
    this.internalValidate[this.targetValidateMethod] = [this.name + 'TargetValidateValue']
    this.internalValidate[this.targetValidateMethod].splice(1, 0, orgParams)
  },
  watch: {
    value (newValue) {
      this.internalValue = newValue
    },
    internalValue (newValue) {
      this.$emit('input', newValue)
    },
    targetValue (newValue) {
      this.$nextTick(() => {
        this.$validator.validate(this.name).then(() => {})
      })
    }
  }
}

</script>
<style scoped>
  .field-input {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/input-target.vue